export default __webpack_public_path__ + "61964b71abffa40ca822a37da6e1a3a5.png";